"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var ChartBase_meta_1 = require("../ChartBase.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

var StyledLastSeriesLabel = InjectedStyledComponent_1.InjectedStyledComponent('text', ChartBase_meta_1.CHART_BASE_CATEGORY_KEY, ChartBase_meta_1.CHART_BASE_COMPONENT_KEY, ['lastSeriesLabel']);
var formatter = ksys_app_template_1.utils.formatter.formatter;

var LastSeriesLabel = function LastSeriesLabel(props) {
  var translationContext = props.translationContext,
      overrides = props.overrides,
      seriesProps = props.seriesProps,
      index = props.index,
      viewBox = props.viewBox,
      stroke = props.stroke,
      rawValue = props.value,
      otherProps = __rest(props, ["translationContext", "overrides", "seriesProps", "index", "viewBox", "stroke", "value"]);

  var _a = overrides,
      enabled = _a.enabled,
      valueFormat = _a.valueFormat,
      _b = _a.props,
      overrideProps = _b === void 0 ? {} : _b;

  if (valueFormat) {
    if (!valueFormat.locale) {
      valueFormat.locale = translationContext && translationContext.culture;
    }

    if (!valueFormat.options) {
      valueFormat.options = {};
    }
  }

  var value = valueFormat ? formatter(valueFormat, rawValue) : rawValue;

  if (enabled && seriesProps && seriesProps.length > 0 && seriesProps.length === index + 1) {
    return React.createElement(StyledLastSeriesLabel, __assign({
      fill: stroke
    }, otherProps, overrideProps), value);
  }

  return null;
};

exports.default = LastSeriesLabel;